// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"e93ec5cf","261":"21b077c8","453":"b0dfaffe","480":"0fa691bb","863":"6e8eb036"}[chunkId] + ".chunk.js";
};